import Button from "../../components/Buttons/Button";
import CustomTooltip from "../../components/toolTipComponent/CustomTooltip";
import TableCustomAppliesToField from "../../components/table/TableCustomAppliesToField";
import TableCustomPriceRangeField from "../../components/table/TableCustomPriceRangeField";
import {
  EditIcon,
  DeleteIcon,
  ActionDotsIcons,
} from "../../../assets/icons/iconsProvider";
import {
  buttonNameConstants,
  buttonTypeConstants,
  SET_BY_TRADE_IN_MARGIN_OPTIONS,
  shopifyConstants,
} from "../../../constants";
import { TableCustomCellWrapper } from "../../components";
import { getActionColumnOfReactDataTableComponent } from "./generic";

//------- Column Headers For Shopify Presets
const getShopifyPresetsColumnHeaders = (handleDeleteClick, handleEditClick) => {
  return [
    {
      id: "setBy",
      name: "Set By",
      selector: (row) => row.marginType,
      cell: (row) => {
        return (
          <TableCustomCellWrapper
            cellValue={
              SET_BY_TRADE_IN_MARGIN_OPTIONS.find(
                (item) => item.value === row.type
              ).label
            }
          />
        );
      },
      sortable: true,
      sortDirection: null,
    },
    {
      id: "appliesTo",
      name: "Applies To",
      selector: (row) => row.markupGroup,
      cell: (row) => {
        return (
          <TableCustomAppliesToField
            row={row}
            groupArray={row.group}
            groupType={row.type}
          />
        );
      },
      sortable: true,
      sortDirection: null,
    },
    {
      id: "priceRange",
      name: "Price Range",
      selector: (row) => row.maxPriceRange,
      cell: (row) => {
        return <TableCustomPriceRangeField row={row} />;
      },
      sortable: true,
      sortDirection: null,
    },
    {
      id: shopifyConstants.LINK_TO_SHOPIFY,
      name: buttonNameConstants.LINK_TO_SHOPIFY,
      selector: (row) => row?.[shopifyConstants.LINK_TO_SHOPIFY],
      cell: (row) => (
        <TableCustomCellWrapper
          cellValue={row?.[shopifyConstants.LINK_TO_SHOPIFY] ? "Yes" : "No"}
        />
      ),
      sortable: true,
      sortDirection: null,
    },
    {
      id: shopifyConstants.SEPERATE_QUANTITY,
      name: buttonNameConstants.SEPARATE_QUANTITY,
      selector: (row) => row?.[shopifyConstants.SEPERATE_QUANTITY],
      cell: (row) => (
        <TableCustomCellWrapper
          cellValue={row?.[shopifyConstants.SEPERATE_QUANTITY] ? "Yes" : "No"}
        />
      ),
      sortable: true,
      sortDirection: null,
    },
    getActionColumnOfReactDataTableComponent((row) => {
      return (
        <>
          <CustomTooltip anchorSelect={`#tool${row.id}`}>
            <Button
              label={buttonNameConstants.EDIT}
              className="w-100"
              buttonType={buttonTypeConstants.ACTION_BUTTON}
              IconImage={EditIcon}
              handleClick={() => handleEditClick(row)}
            />
            <Button
              label={buttonNameConstants.DELETE}
              className="w-100"
              type="button"
              buttonType={buttonTypeConstants.ACTION_BUTTON}
              IconImage={DeleteIcon}
              handleClick={() => handleDeleteClick(row.id)}
            />
          </CustomTooltip>
          <button id={`tool${row.id}`} className="action-Button-Wrapper">
            <ActionDotsIcons className="cursor-pointer" />
          </button>
        </>
      );
    }),
  ];
};

export { getShopifyPresetsColumnHeaders };
